import { LeadFormData } from "../blocks/LeadForm/LeadFormModal";

interface GetPdfDownloadLink {
  (
    params: Partial<LeadFormData> & {
      filename: string;
      orientation: "landscape" | "portrait";
      path: string;
      sso: string;
    }
  ): string;
}

export const getPdfDownloadLink: GetPdfDownloadLink = ({
  filename,
  orientation,
  path,
  sso,
  ...leadFormData
}) => {
  const queryString = new URLSearchParams({
    ...leadFormData,
    filename,
    orientation,
    sso,
    url: `${window.location.origin}${path}`,
  }).toString();

  return `/pdf?${queryString}`;
};
